import script from "./MatchingDetailCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatchingDetailCard.vue?vue&type=script&setup=true&lang=ts"

import "./MatchingDetailCard.vue?vue&type=style&index=0&id=4974fd6e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4974fd6e"]])

export default __exports__